<template>
  <div>
    <div class="cmpnt-modal-box" v-if='islayer'>
      <div class="lmy-mask-s"></div>
      <div class="lmy-modal">
        <div class="lmy-modal-head">输入优惠码</div>
        <div class="lmy-modal-input">
          <input type="text" v-model="coupon">
        </div>
        <div class="lmy-modal-foot">
          <div class="sort-btn" @click="hideLayer">取消</div>
          <div class="sort-btn" @click="checkCoupon">提交</div>
        </div>
      </div>
    </div>
    <header class="lmy-header lmy-header-w">
      <i class="iconfont icon-yuyin" onclick="window.history.go(-1)"></i>
      立即抢购
    </header>
    <div class="lmy-purchase">
      <div class="rush-text">
        {{ details.Name }}
      </div>

      <div class="lmy-pur-content">
        <div class="content-head"><i class="iconfont icon-ruwangxuzhi"></i>抢购须知</div>
        <div class="content-body" v-html="details.PurchaseNotes">

        </div>
      </div>
      <div class="select-count">
        <div class="select-count-item">
          数量选择
        </div>
        <div class="select-count-item-a">
          <span class="price">￥{{ details.SalePrice }}/套</span>
          <span style="margin-left: 2.8rem;color:#ff6600" v-if="details.MaxBookCounts">限购{{details.MaxBookCounts}}份</span>
          <div class="compute">
            <span class="sub" @click="reduceNumber">-</span>
            <span class="count">{{ count }}</span>
            <span class="plus" @click="addNumber">+</span>
          </div>
        </div>
        <div class="select-count-item coupon" @click="showLayer()" v-if="routerParam">
          <div class="couponText">招商银行优惠码</div>
          <i class="iconfont icon-more"></i>
        </div>
        <div class="select-count-item coupon" v-if="newAmount">
          <p>抵用券：-￥{{ couponPrice }}</p>
          <i class="iconfont icon-close" @click="clearData"></i>
        </div>
        <div class="select-count-item">
          <span class="total" v-if="newAmount">合计：￥{{ newAmount }}</span>
          <span class="total" v-else>合计：￥{{ details.SalePrice * count }}</span>
        </div>
      </div>
      <div class="room-people-toast">港澳及海外产品必须填写英文或拼音<!--<i class="iconfont icon-guanbi"></i>--></div>
       <!-- v-for="item,index in Guests" -->
      <div class="input-people" v-if="details.NeedFullUserInfo"> 
        <div class="left">游客信息</div>
        <div class="right">
          <!-- <div v-for="(m,i) in item"> -->
          <div v-for="m,index in Guests">
            <div class="title">出行人{{index+1}} <i v-if="index>0 && count==0" class="iconfont icon-guanbi"></i></div>
            <div class="input-people-item">
              <div class="input-box is-border">
                <input type="text"  v-model="m.FirstName" placeholder="游客姓">
              </div>
              <div class="input-box">
                <input type="text"  v-model="m.LastName" placeholder="游客名">
              </div>
            </div>
            <div class="input-people-item" v-if="details.NeedCardNO">
              <div class="select-box is-border">
                <select v-model="m.CardType">
                  <option disabled value='0'>证件类型</option>
                  <option value='1'>身份证</option>
                  <option value='16'>学生证</option>
                  <option value='8'>军人证</option>
                  <option value='4'>护照</option>
                  <option value='2'>港澳通行证</option>
                  <option value='32'>台湾通行证</option>
                </select>
              </div>
              <div class="input-box" style="width: 3rem;">
                <input type="text" placeholder="输入证件号" v-model="m.CardNumber">
              </div>
            </div>
          </div>

        </div>
      </div>
      
      <!-- <div class="receiver" v-if="details.NeedDelivery">
        <div class="content-head">
          收货信息
        </div>
        <div class="menu-item">
          <div class="item-label">收货人</div>
          <div class="item-content"><input type="text" placeholder="请填写" v-model="ReceiverName"></div>
        </div>
        <div class="menu-item">
          <div class="item-label">收货电话</div>
          <div class="item-content"><input type="text" placeholder="请填写" v-model="ReceiverPhone"></div>
        </div>
        <div class="menu-item">
          <div class="item-label">收货地址</div>
          <div class="item-content"><textarea ref="textBox" placeholder="请填写" style="height:auto"
                                              v-model="ReceiveAddress"></textarea></div>
        </div>
      </div> -->
      <div class="select-count" v-if="details.NeedName">
        <div class="select-count-item-a">
          <span>联系人</span>
          <div class="room-tel-content">
            <input type="text" v-model="nikename"></div>
        </div>
      </div>
      <div class="select-count" v-if="details.NeedMobile">
        <div class="select-count-item-a">
          <span>联系电话</span>
          <div class="room-tel-content">
            <input type="text" v-model="phone" placeholder="用于接收短信通知"></div>
        </div>
      </div>
      <div class="select-count" v-if="details.NeedCardNO" style="display: flex;justify-content: flex-start;align-items: center;">
              <div class="select-count-item-a" style="width:30%">
                <select v-model="cardType">
                  <option disabled value='0'>证件类型</option>
                  <option value='1'>身份证</option>
                  <option value='16'>学生证</option>
                  <option value='8'>军人证</option>
                  <option value='4'>护照</option>
                  <option value='2'>港澳通行证</option>
                  <option value='32'>台湾通行证</option>
                </select>
              </div>
              <div class="room-tel-content" style="width: 4rem;">
                <input type="text" placeholder="输入证件号" v-model="cardNumber">
              </div>
            </div>
      <div class="select-count" v-if="details.NeedEmail">
        <div class="select-count-item-a">
          <span>邮箱</span>
          <div class="room-tel-content">
            <input type="email" v-model="email" placeholder="用于接收邮件通知"></div>
        </div>
      </div>
      <div class="select-count" style="margin-bottom: 1rem">
        <div class="select-count-item-a">
          <span>买家留言</span>
          <div class="room-tel-content">
            <input type="text" v-model="SpecialRequest" placeholder="如有特殊需求，请在这里留言"></div>
        </div>
      </div>
      <div class="order-btn">
        <div v-if="newAmount">应付：<label class="price">¥ <span class="num">{{ newAmount }}</span></label></div>
        <div v-else>应付：<label class="price">¥ <span class="num">{{ details.SalePrice * count }}</span></label></div>

        <div class="submit-btn" @click="check">去支付</div>
      </div>

      <!-- <div class="order-btm">
          <div class="price">
              <span class="new">
                  ￥<span>{{details.SalePrice*count}}</span>
              </span>
              <span class="old">省￥{{details.MarketPrice*count-details.SalePrice*count}}</span>
          </div>
          <div class="pay-btn" @click="check">去支付</div>
      </div> -->
    </div>
    <div class="book-comfirming" v-if="isCheck">
      <div class='f-modal'>
        <div class='f-modal-head'>提示</div>
        <div class='f-modal-body'>
          <p>正在查询库存信息，请稍候</p>
        </div>
      </div>
    </div>
    <div class="book-comfirming" v-if="isCreate">
      <div class='f-modal'>
        <div class='f-modal-head'>提示</div>
        <div class='f-modal-body'>
          <p>正在下单，请稍候</p>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: '',
  data() {
    return {
      details: JSON.parse(this.dao.get('presaleDetails')),
      count: 1,
      phone: JSON.parse(this.dao.get('userInfo')).Phone,
      nikename: '',
      email: '',
      cardType: 0,
      cardNumber:'',
      isCheck: false,
      isCreate: false,
      SpecialRequest: '',
      Guests:[],
      islayer: false,//是否弹框
      coupon: '',//优惠券码
      couponToken: '',//优惠券token
      newAmount: '',//用券新价格
      couponPrice: '',//优惠额度
      routerParam: '',//页面来源参数
    }
  },
  watch: {
    ReceiveAddress(item) {
      this.$refs.textBox.style.height = 'auto'
      this.$refs.textBox.style.height = Math.min(this.$refs.textBox.scrollHeight, 60) + 'px'
    },
    count(val) {
      this.isPersonNum();
    }
  },
  methods: {
    isPersonNum(){
            if(this.count == 0){
              this.Guests = [
                  {'FirstName':'','LastName':'','CardNumber':'','CardType':0}
              ]
            }else{
              var lis = [];
              for(var i=0; i<this.count;i++){
                var item = {
                  'FirstName': '',
                  'LastName': '',
                  'CardNumber': '',
                  'CardType': 0
                }
                lis.push(item);
              }
              this.Guests=lis
            }
          },

    // 增加产品数量
    addNumber() {
      if (this.details.MaxBookCounts){
        if (this.newAmount&&this.count<this.details.MaxBookCounts) {
          this.count++;
          this.checkCoupon()
        }else {
          this.count++;
          this.count>=this.details.MaxBookCounts?this.count=this.details.MaxBookCounts:this.count;
        }
        
      }else {
        if (this.newAmount&&this.count<99) {
          this.count++;
          this.checkCoupon()
        }else {
          this.count++;
          this.count>=99?this.count=99:this.count;
        }
      }
      
    },

    // 减少产品数量
    reduceNumber() {
      if (this.newAmount&&this.count>1) {
        this.count--;
        this.checkCoupon()
      }else {
        this.count--;
        this.count<=1?this.count=1:this.count;
      }
    },

    // 清除券码数据
    clearData () {
        this.coupon ='',//优惠券码
        this.couponToken = '', // 优惠券token
        this.newAmount = '',//用券新价格
        this.couponPrice = ''//优惠额度
    },

    //优惠券码验证
    checkCoupon() {
      var that = this;
      var params = {
        Count: that.count,
        Token: that.details.Token,
        Code: that.coupon
      }
      that.islayer = false
      if(!that.coupon) {
        this.$alert("请填写优惠券码")
        return
      }
      that.postRequest({
        url: that.Api.checkCoupon,
        params: params
      }).then(res => {
        if (res && res.IsSuccess) {
          console.log(res)
          that.couponToken = res.Result.Token
          that.newAmount = res.Result.NewAmount
          let Amount = that.details.SalePrice * that.count - that.newAmount
          that.couponPrice = Amount.toFixed(1)
          // console.log(that.couponPrice)
        } else {
          that.$alert("抱歉！该券码无效或已被使用");
          that.clearData()
        }
      });

    },

    check() {
      if (this.details.NeedDelivery) {
        if (!this.ReceiverName.trim() || !this.ReceiverPhone.trim() || !this.ReceiveAddress.trim()) {
          this.$alert("请正确填写收货信息!")
          return
        }
        if (!this.checkMobile(this.ReceiverPhone)) return;
      }
      var that = this;
      that.isCheck = true;
      var params = {
        Count: that.count,
        Token: that.details.Token,

      }
      that.postRequest({
        url: that.Api.preSaleBook,
        params: params
      }).then(res => {
        that.isCheck = false;
        if (res && res.IsSuccess) {
          that.create();
        } else {
          this.error({title: '提示', content: res.Msg});
        }
      });
    },
    create() {
      var that = this;
      that.isCreate = true;
      var params = {
        Token: that.details.Token,
        Count: that.count,
        CouponToken: that.couponToken,
        SpecialRequest: that.SpecialRequest,
        Guests: that.Guests,
        CreditType: that.cardType,
        CreditNo: that.cardNumber,
        ContactUser: that.nikename,
        Phone: that.phone,
        GuestEmail: that.email,

      }
      that.postRequest({
        url: that.Api.preSaleCreate,
        params: params
      }).then(res => {
        that.isCreate = false;
        if (res && res.IsSuccess) {
          that.OrderNO = res.Result.MainOrderID;
          that.dao.set('thisBookingOrderNO', res.Result.MainOrderID);
          this.$router.push({path: '/WxPay', query: {OrderNO: this.OrderNO}});
        } else {
          this.error({title: '提示', content: res.Msg});
        }

      });
    },
    // 弹框显示
    showLayer () {
      this.islayer = true
    },
    //弹框隐藏
    hideLayer () {
      this.islayer = false
    },
  },
  mounted(){
    this.isPersonNum();
    console.log(this.Guests)
  }

}
</script>



// WEBPACK FOOTER //
// src/components/activity/book.vue